export default __webpack_public_path__ + "static/media/undraw_version.809f3c51.svg";